/**
 * @generated SignedSource<<c492d0b7fb274b7b3dcb6bfe038fe033>>
 * @relayHash ecc7182ff5423f7b64194c3b9a61e4c8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ecc7182ff5423f7b64194c3b9a61e4c8

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
export type ConsultationFeedbackReason = "AGE_BAND" | "AREA_OF_EXPERTISE" | "LANGUAGE_CONFIDENCE" | "OTHER";
export type NotBillableReason = "ADMINISTRATIVE" | "INCOMPLETE_CONSULTATION" | "OTHER_REASON";
export type TreatmentReason = "ACCIDENT" | "CONGENITAL_DEFECT" | "MATERNITY" | "PREVENTION" | "SICKNESS";
export type ConcludeAppointmentInput = {
  agentFeedback?: AgentConsultationFeedbackInput | null;
  collectBillingInput: CollectBillingDataInput;
  id: string;
  inboundCallId?: number | null;
  shouldIncreaseMissedCall: boolean;
};
export type AgentConsultationFeedbackInput = {
  likedConsultation: boolean;
  otherReasonText?: string | null;
  reason?: ConsultationFeedbackReason | null;
};
export type CollectBillingDataInput = {
  accidentReference?: string | null;
  appointmentId: string;
  currentGestationWeek?: number | null;
  dateOfAccident?: any | null;
  isEmployer?: boolean | null;
  isNotBillable: boolean;
  isPatientPregnant?: boolean | null;
  isVisualSymptomExamination?: boolean | null;
  ivgCaseReference?: string | null;
  notBillableReason?: NotBillableReason | null;
  organisationId?: string | null;
  patientAge?: number | null;
  patientOrganisationKey?: string | null;
  reason?: string | null;
  treatmentReason?: TreatmentReason | null;
};
export type useConcludeAppointmentMutation$variables = {
  input: ConcludeAppointmentInput;
};
export type useConcludeAppointmentMutation$data = {
  readonly concludeAppointment: {
    readonly appointment: {
      readonly completedAt: string | null;
      readonly id: string;
      readonly isCompleted: boolean;
      readonly status: AppointmentStatus;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useConcludeAppointmentMutation = {
  response: useConcludeAppointmentMutation$data;
  variables: useConcludeAppointmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Appointment",
  "kind": "LinkedField",
  "name": "appointment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useConcludeAppointmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ConcludeAppointmentPayload",
        "kind": "LinkedField",
        "name": "concludeAppointment",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useConcludeAppointmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ConcludeAppointmentPayload",
        "kind": "LinkedField",
        "name": "concludeAppointment",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ecc7182ff5423f7b64194c3b9a61e4c8",
    "metadata": {},
    "name": "useConcludeAppointmentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7317825f98307470b146dd1e67f1b6cf";

export default node;
